import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import clsx from 'clsx';

import Header from '@components/layout/Header';
import { Footer } from '@components/layout/Footer';
import SEOHead from '@components/SEOHead';

export default function Terms({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) {
  const outerClasses = clsx(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className,
  );

  return (
    <>
      <SEOHead
        title="AI girlfriend WTF - Terms of service"
        description="Terms of service for AI girlfriend wtf, app where you can chat with ai girls, make your own actions in adventure "
        type="website"
        keywords="AI girlfriend terms, virtual girlfriend, AI girl simulator, AI story, adventure ai game"
        url="https://www.aigirlfriend.wtf/terms"
        imageUrl="https://www.aigirlfriend.wtf/web-banner-min.jpg"
      />
      <Header navPosition="right" className="reveal-from-bottom" />
      <br />
      <br />
      <br />

      <main {...props} className={outerClasses}>
        <div className="container-sm">
          <h4>Terms of Service</h4>
          <font size="3">
            <h5>Acceptance of the Terms of Service</h5>
            <p>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              By accessing or using www.aigirlfriend.wtf (the "Platform"), or
              participating in any associated communities, you accept and
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              agree to be bound by these Terms of Service ("Terms") and our
              [Privacy Policy], incorporated by reference. All visitors and
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              users are referred to as "you" or "Users". The agreement is
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              between you and AIGirlfriend. ("aigirlfriend.wtf", "us", "we").
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              "Content" encompasses any information submitted by users,
              including text, images, videos, and other materials shared or
              posted on the Platform. Please note: Any dispute resolution is
              handled through arbitration. Not enforcing a provision does not
              mean we waive the right to enforce it later.
            </p>

            <h5>Eligibility and Age Requirement</h5>
            <p>
              The Platform is designed for those 18 years and older. If under
              18, please refrain from accessing or using our service.
              Misrepresenting your age can lead to account termination.
            </p>

            <h5>Changes to the Terms of Service</h5>
            <p>
              We can modify these Terms at any given time. Users are encouraged
              to review the Terms periodically. Continued use post-modifications
              signifies your acceptance. The latest version is always available
              at https://www.aigirlfriend.wtf/terms.
            </p>

            <h5>Access to the Platform</h5>
            <p>
              We grant you a personal, non-commercial license to access and use
              the Platform. We may modify, pause, or halt the Platform anytime
              without notice. You acknowledge no rights to any support or
              maintenance. Intellectual property rights are owned by us, and
              these Terms do not transfer any ownership rights.
            </p>

            <h5>User Content Responsibility</h5>
            <p>
              You are solely accountable for your Content and the consequences
              of posting or publishing it. Ensure your Content aligns with our
              guidelines and does not imply our endorsement.
            </p>

            <h5>Prohibited Content</h5>
            <p>
              Ensure your Content does not: Promote illegal activities.
              Encourage violence, hate, or discrimination. Involve minors in
              inappropriate ways. Share personal information without consent.
              Infringe intellectual property rights. Bypass our security or
              moderation.
            </p>

            <h5>Acceptable Use</h5>
            <p>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              You pledge not to misuse the Platform in ways that violate these
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              Terms or any law. Respect others' rights and do not harass, harm,
              or disrupt the service for others.
            </p>

            <h5>Feedback and Suggestions</h5>
            <p>
              Feedback is appreciated. By sharing, you grant us all rights to
              the feedback and allow us to use it without restrictions. All
              feedback is non-confidential and non-proprietary.
            </p>

            <h5>Indemnification</h5>
            <p>
              You agree to defend and hold harmless aigirlfriend.wtf and its
              staff from any claims, damages, liabilities, or costs arising from
              your Content, your use of the Platform, or your violation of these
              Terms.
            </p>

            <h5>Termination and Account Suspension</h5>
            <p>
              We reserve the right to suspend or terminate your access to the
              Platform if you violate these Terms or if we believe, at our sole
              discretion, that your conduct poses a risk or liability to our
              users, or for any other reason, with or without notice.
            </p>
            <h5>Disclaimers</h5>
            <p>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              The Platform is provided "as is" and "as available" without any
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              warranties of any kind, either express or implied. We don't
              guarantee that the platform will always be safe, secure, or
              error-free or that the platform will always function without
              disruptions, delays, or imperfections.
            </p>
            <h5>Limitation of Liability</h5>
            <p>
              To the fullest extent permitted by applicable law, AIGirlfriend.
              shall not be liable for any indirect, incidental, special,
              consequential, or punitive damages, or any loss of profits or
              revenues, whether incurred directly or indirectly, or any loss of
              data, use, goodwill, or other intangible losses resulting from
              your use or inability to use the Platform.
            </p>
            <h5>Third-party Services and Content</h5>
            <p>
              Our Platform might have links to third-party websites, services,
              or features, or include them on our platform. We don’t control
              these third-party services, and we’re not responsible for their
              content or for any transaction you might enter into with them.
            </p>
            <h5>Governing Law and Jurisdiction</h5>
            <p>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              These Terms and any dispute arising from or relating to these
              Terms or your use of the Platform will be governed by and
              construed in accordance with the laws of [Specific Jurisdiction,
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              e.g., "the State of California"], without regard to its conflict
              of law principles.
            </p>
            <h5>Contact Information</h5>
            <p>
              For any queries or concerns regarding these Terms, please contact
              us at contact@aigirlfriend.wtf.
            </p>
            <p>Last updated: 01 Sep 2023</p>
          </font>
        </div>
      </main>

      <Footer />
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['header', 'footer'])),
    },
  };
}
